import { FormatOptions, create, format, unitDependencies } from 'mathjs';

const math: math.MathJsStatic = create(
  { unitDependencies },
  {
    number: 'BigNumber',
  }
);

const convertUnits = (
  value: number,
  source: string,
  target: string,
  formatOptions?: FormatOptions
): number => {
  const unit = math.unit(value, source);
  let converted = unit.toNumber(target);

  if (formatOptions) {
    converted = parseFloat(format(converted, { ...formatOptions }));
  }

  return converted;
};

const formatNumber = (value: number, step: number): number => {
  const precision = decimalCount(step);
  return Number(format(value, { notation: 'fixed', precision }));
};

const decimalCount = (num: number) => {
  // Convert to String
  const numStr = String(num);
  // String Contains Decimal
  if (numStr.includes('.')) {
    return numStr.split('.')[1].length;
  }
  // String Does Not Contain Decimal
  return 0;
};

const mapUnitOfMeasureToLabel = (uom: string) => {
  switch (uom) {
    case 'in/min':
      return 'ipm';
    case 'cm/min':
      return 'cpm';
    default:
      return uom;
  }
};

export { convertUnits, formatNumber, mapUnitOfMeasureToLabel };
